const translation = {
  offRules: 'Oficialios taisyklės',
  // Navigation pages
  play: 'ŽAISTI',
  recent: 'Ankstesni',
  howToPlay: 'Kaip žaisti',

  // Card
  signUp: 'Prisijunk žaisti',
  viewMy: 'Žiūrėti mano kortelę',
  view: 'PERŽIŪRĖTI ŽEMĖLAPĮ',
  registered: 'Užregistruotas',
  entry: 'Dalyvis',
  entries: 'Dalyviai',
  contestClosed: 'Bingo žaidimas uždarytas',
  ifNecessary: 'Jeigu būtina',

  //Signup modal
  reg: 'Jūs užregistruotas žaidime Bingo',
  rel: 'Jūsų Bingo kortelė bus parodyta po:',
  come: 'Grįžkite, kai prasidės rungtynės, kad pamatytumėte savo kortelę.',
  priz: 'Prizai',
  regen: 'ŽAIDIMO METU BINGO KORTELĖJE AUTOMATIŠKAI SKIRIAMI TAŠKAI',
  //Wait modal
  hangTight: 'Tęskite!',
  cardToBeGenerated: 'Laukiama kol bus sugeneruota Bingo kortelė',
  mayTakeUpFewMinutes: 'TAI GALI UŽIMTI KELIAS MINUTES',

  // How to play page
  vert: 'VERTIKALĖ',
  horiz: 'HORIZONTALĖ',
  diag: 'ĮSTRIŽAINĖ',
  fullCard: 'Pilna kortelė',
  earnEntriesIntoDraw:
    'LAIMĖKITE PRIZUS UŽBRAUKDAMI PILNAS EILUTES, ĮSTRIŽAINES AR VISĄ KORTELĘ. LANGELIS SKAITOSI LAIMĖTAS, JEIGU JAME ESANTIS ĮVYKIS ĮVYKO.',
  earnEntryIntoDraw:
    'TURĖK GALIMYBĘ LAIMĖTI PRIZUS UŽBRAUKDAMAS EILUTES ARBA ĮSTRIŽAINES. JŪSŲ LANGELIS SKAITOSI UŽBRAUKTAS JEIGU NURODYTAS ĮVYKIS JAME RUNGTYNĖSE ĮVYKO.',
  autoScoresDuringGame: 'BINGO KORTELĖ AUTOMATIŠKAI ATSINAUJINA RUNGTYNIŲ METU',
  clickForMoreInfo:
    'Norėdami gauti daugiau informacijos, spauskite čia perskaityti taisykles',
  SOG: 'SOG - smūgis į vartus (bet koks smūgis į vartus. Neįtraukiami užblokuoti arba į vartus pataikę smūgiai).',
  PPG: 'PPG - Power Play Goals (įvarčiai, pelnyti komandai žaidžiant pratęsimą). Pavyzdžiui, komanda, žaidžianti 5v4, 5v3 arba 4v3).',
  SHG: 'SHG - įvarčiai, pelnyti iš baudos aikštelės (įvarčiai, kuriuos įmušė komanda, kurios žaidėjas atlieka bausmę)',
  PIM: 'PIM - baudos minutėmis',
  FOPercent: 'FO% - kritimų procentas',
  PTS: 'PTS - taškai (įvarčiai arba rezultatyvūs perdavimai)',
  entryPerRow: 'DALYVIS PER EILĘ',
  totalEntries: 'VISO DALYVIŲ',
  perRow: 'Į VIENĄ EILĘ',

  //Home page
  bingoMayTakeUp:
    'Bingo kortelių rezultatų patvirtinimas gali užtrukti iki 20 minučių',
  welcomeTo: 'Sveiki atvykę į BingOly!',
  reviewInRecent: "Savo paskutines korteles gali matyti skiltyje 'Ankstesni'",
  noBingolyGames:
    'No BingOly Games currently available. Come back soon to play!',
  thanksForPlaying:
    'Ačiū, kad žaidžiate Olybet Bingo! Peržiūrėkite savo 2022-2023 m. sezono korteles skiltyje „Naujausi“',
  agreeToRules:
    'Prisijungdami, Jūs patvirtinate, kad susipažinote ir sutinkate su oficialiomis taisyklėmis',

  //Recent page
  noRecentContests: 'Nėra ankstesnių žaidimų',
  //Game field page
  gamePrizeText:
    'Laimėkite 100 eurų, jei pavyks užpildyti visas kortas, arba 5 eurus, jei pavyks užpildyti bent vieną eilutę ar įstrižainę. Prizai bus dalijami darbo valandomis.',
  cardUpdateAfterPeriod: 'Kortelė atsinaujina kas 30 minučių.',
  anyLine: 'Bet kokia linija',
  vertLines: 'VERTIKALIOS LINIJOS',
  line: 'LINIJA',
  horzLines: 'HORIZONTALI LINIJA',

  //Onboarding page
  letsGetStarted: 'Pradėkime!',
  makeSureToEnterSelections:
    'Įsitikinkite, kad kasdien įvedate savo pasirinkimus ir varžotės dėl kasdienių prizų. Nepamirškite prieš pateikdami savo pasirinkimą įvesti lygiųjų klausimą. Savo pasirinkimus galite redaguoti iki pat tiesioginio žaidimo pradžios. Už kiekvieną teisingą prognozę pelnykite taškų.',
  playWithFriends:
    'Žaiskite su draugais. Kas žaidžia? Meskite iššūkį draugams ir dalyvaukite privačioje lygoje. Eikite į lyderių lentelę, spustelėkite Sukurti, kad pradėtumėte, ir pasidalykite PIN kodu su draugais, kad jie prisijungtų.',
  scoring: 'Skaičiuojami taškai',
  challengeFriends: 'Meskite iššūkį draugams',
  skip: 'praleisti',
  next: 'kitas',

  logout: 'Atsijungti',
  returnToGamezone: 'Grįžti į GameZone',
  rules: 'Taisyklės',
  back: 'Atgal',

  bingo: 'Bingo',
  gamezone: 'Gamezone',
  justAFewMinutes: 'Tik kelios minutės, prašau, atnaujinkite puslapį',
  fourCorners: 'KETURI KAMPAI',
  rulesNotFound: 'Taisyklių nerasta',
  offWebsiteText:
    'OFICIALUS RUNGTYNIŲ PUSLAPIS BUS NAUDOJAMAS KAIP PAGRINDINIS REZULTATŲ ŠALTINIS.',
  accountInfo: 'Paskyros duomenys',
  availableGames: 'Galimi žaidimai',
  backToOlybet: 'Grįžti į OlyBet',
  confirmNewPassword: 'Patvirtinkite naująjį slaptažodį',
  confirmNewPasswordIsRequired:
    'Naujo slaptažodžio patvirtinimas yra privalomas laukas',
  confirmPassword: 'Patvirtinti slaptažodį',
  confirmPasswordIsRequired: 'Patvirtinti slaptažodį - privalomas laukas',
  contactNumber: 'Kontaktinis numeris',
  country: 'Gyvenamosios vietos šalis',
  countryIsRequired: 'Šalis - privalomas laukas',
  continue: 'TĘSTI',
  days: 'Kasdien',
  didNotMeanToUnsubscribe: 'Atsitiktinai nutraukėte prenumeratą?',
  email: 'El. paštas',
  emailAddressAlreadyInUse: 'Jau naudojamas el. pašto adresas',
  emailIsRequired: 'El. paštas yra privalomas laukas',
  emailOrUsername: 'El. paštas arba vartotojo vardas',
  emailOrUsernameIsRequired:
    'El. paštas arba vartotojo vardas yra privalomas laukas',
  enterYourDetails: 'Toliau įveskite savo duomenis',
  enterYourEmail:
    'Įveskite savo el. pašto adresą, kad iš naujo nustatytumėte slaptažodį',
  errorDuringLogin: 'Klaida prisijungimo metu',
  errorDuringRegistration: 'Registracijos klaida',
  errorDuringSubscribing: 'Klaida prenumeruojant',
  errorDuringUnsubscribing: 'Klaida atšaukimo metu',
  errorUpdatingProfile: 'Atnaujinant profilį įvyko klaida',
  firstName: 'Vardas',
  firstNameIsRequired: 'Vardas yra privalomas laukas',
  firstNameMusBeAtLeast: 'Pavadinimas turi būti ne trumpesnis kaip 3 ženklai.',
  firstNameMustNotExceed: 'Pavadinimas neturi viršyti 100 simbolių',
  forgotPassword: 'Pamiršote slaptažodį',
  full: 'PILNS',
  gameDetails: 'Žaidimo informacija',
  getResetLink: 'Gaukite atstatymo nuorodą',
  goodbye: 'Iki pasimatymo!',
  inappropriateWordsNotAllowed: 'Nepadorūs žodžiai ir frazės neleistini',
  informationAndPromotionalAgreement:
    'Sutinku su šio Žaidimo taisyklėmis bei patvirtinu, kad Žaidimo taisyklės man yra priimtinos, aiškios bei suprantamos. Patvirtinu, kad esu susipažinęs su taisyklėmis, kurios skelbiamos adresu:',
  inOrderToPlayAndRedeemPrizes:
    'Kad galėtumėte žaisti ir pretenduoti į prizus, jūsų kontaktiniai duomenys turi būti tikslūs ir patvirtinti. Kai kurie prizai pervedami į jūsų „OlyBet“ sąskaitą. Norėdami atsiimti šiuos prizus, turite turėti „OlyBet“ paskyrą su teisingais duomenimis (vardu, pavarde ir el. paštu).',
  invalidCredentials: 'Neteisingi įgaliojimai',
  invalidEmailFormat: 'Netinkamas el. pašto formatas',
  itIsRequiredField: 'Tai privalomas laukas',
  joinNow: 'Prisijunkite prie',
  lastName: 'Pavardė',
  laststNameIsRequired: 'Pavardė yra privalomas laukas',
  laststNameMusBeAtLeast: 'Pavardę turi sudaryti ne mažiau kaip 3 simboliai',
  laststNameMustNotExceed: 'Pavardė neturi viršyti 100 simbolių',
  legalConsent:
    'Sutinku, kad mano asmens duomenys būtų tvarkomi Žaidimo vykdymo bei skundų nagrinėjimo tikslais. Patvirtinu, kad esu susipažinęs su Privatumo politika, kuri skelbiama adresu:',
  lines: 'LINIJOS',
  live: 'LIVE',
  liveGames: 'Tiesioginiai žaidimai',
  login: 'Prisijungimas',
  marketingConsent:
    'Sutinku, kad mano asmens duomenys būtų tvarkomi tiesioginės rinkodaros tikslais.',
  marketingConsentSidebar: 'Sutikimas dėl rinkodaros',
  mobileNumber: 'Mobiliojo telefono numeris',
  mobileNumberIsRequired: 'Mobiliojo telefono numeris yra privalomas laukas',
  mobileNumberMustBeAtLeast:
    'Mobiliojo telefono numerį turi sudaryti ne mažiau kaip 6 simboliai.',
  mobileNumberMustNotExceed:
    'Mobiliojo telefono numeris negali būti ilgesnis nei 15 simbolių.',
  mustBeChecked: 'Reikia patikrinti',
  mustContainFrom8To20Characters: 'Must contain from 8 to 20 characters',
  mustContainOneLowercase: 'Must contain at least one lowercase',
  mustContainOneNumber: 'Must contain at least one number',
  mustContainOneUppercase: 'Must contain at least one uppercase',
  myContest: 'Mano lenktynės',
  myHistory: 'Mano istorija',
  nationality: 'Pilietybė',
  newPassword: 'Naujas slaptažodis',
  newPasswordIsRequired: 'Naujas slaptažodis yra privalomas laukas',
  nickname: 'Slapyvardis',
  nicknameAlredyInUse: 'Jau naudojamas slapyvardis',
  nicknameIsRequired: 'Slapyvardis yra privalomas laukas',
  noHistoryYet: 'Dar nėra istorijos',
  noUpcomingContestsYet: 'Būsimų kvietimų teikti paraiškas dar nėra',
  oops: 'Hmm! Kažkas nutiko ne taip...',
  over$PrizeValueWon: 'Laimėta daugiau nei <1>1,000,000$</1> prizo vertė',
  password: 'Slaptažodis',
  passwordDoNotMatch: 'Slaptažodžiai nesutampa',
  passwordIsRequired: 'Slaptažodis yra privalomas laukas',
  passwordNotMeetCriteria: 'Slaptažodis neatitinka kriterijų',
  passwordSuccessfullyReset: 'Slaptažodis sėkmingai atstatytas',
  personalDetails: 'Asmeninė informacija',
  playNow: 'Žaisti dabar',
  pleaseCheckYourEmailInbox: 'Prašome patikrinti savo el. pašto dėžutę',
  pos: 'Poz.',
  preferences: 'Sutikimai',
  profile: 'Profilis',
  pts: 'PTS',
  recentWinners: 'Naujausi laimėtojai',
  region: 'Regionas',
  resetLinkSent: 'Atstatymo nuoroda išsiųsta',
  resetPassword: 'Atstatyti slaptažodį',
  resubscribe: 'Prenumeruoti iš naujo',
  returnToLogin: 'Grįžti prie prisijungimo',
  saveChanges: 'Išsaugoti pakeitimus',
  signIn: 'Prisijungti',
  success: 'Pavyko!',
  successfullyLoggedIn: 'Sėkmingai prisijungėte',
  successfullySentResetLink:
    'Atstatymo nuoroda sėkmingai išsiųsta į jūsų el. paštą',
  successfullySignedUp: 'Pavyko!',
  successfullySubscribed: 'Sėkmingai užsiprenumeravote',
  successfullyUnsubscribed: 'Sėkmingai atsisakyta prenumeratos',
  successfullyUpdatedProfile: 'Profilis sėkmingai atnaujintas',
  unsubscribe: 'Atsisakyti pranešimų',
  upload: 'Įkelti',
  username: 'Vartotojo vardas',
  usernameAlreadyInUse: 'Vartotojo vardas jau naudojamas',
  usernameIsRequired: 'Vartotojo vardas yra privalomas laukas',
  veryStrongPassword: 'Labai stiprus slaptažodis',
  welcomeBack: 'Sveiki sugrįžę!',
  win: 'LAIMĖTI',
  winner: 'Laimėtojas',
  youHaveSuccesfullyUnsubscribed: 'Sėkmingai atsisakėte „OlyBet“ pranešimų.',
  yourEmail: 'Jūsų el. paštas',
  youWishToUnsubscribe:
    'Jei esate tikri, kad norite atsisakyti „OlyBet“ pranešimų prenumeratos, spustelėkite žemiau.',
  zipCode: 'Pašto kodas',
  zipCodeIsRequired: 'Pašto kodas yra privalomas laukas',
  zipCodeMustBeAtLeast: 'Pašto kodas turi būti bent 3 simbolių',
  zipCodeMustNotExceed: 'Pašto kodas neturi viršyti 10 simbolių',
  winPrizes:
    'LAIMĖKITE PRIZUS, RUNGTYNIŲ METŲ UŽBRAUKDAMI LINIJAS SAVO BINGO KORTELĖJE',
  letsGo: 'Žaiskime',
  inAnyCase:
    'Informuojame, kad mes vis tiek susisieksime su jumis dėl itin svarbios informacijos, susijusios su Jūsų dalyvavimu žaidime, pavyzdžiui, patvirtinimo apie laimėtą prizą. Daugiau informacijos apie tai, kaip tvarkomi jūsų asmens duomenys, rasite mūsų Privatumo Politikoje.',
  termsAndConditions: 'Sąlygos ir nuostatos',
  privacyNotice: 'Privatumo pranešimas',
};
export default translation;
